var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAttachmentPin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m14.909 14.058 2.44-3.175.07.072a1.43 1.43 0 0 0 2.033 0l.127-.128a1.457 1.457 0 0 0 0-2.049L15.26 4.424a1.43 1.43 0 0 0-2.033 0l-.127.128a1.457 1.457 0 0 0 0 2.05l.072.071-3.15 2.459-.097-.098a1.786 1.786 0 0 0-2.541 0l-.254.256a.91.91 0 0 0 0 1.28l2.328 2.348-5.416 6.785c-.135.17.085.39.252.255l6.732-5.46 2.456 2.475c.35.354.92.354 1.27 0l.254-.256a1.821 1.821 0 0 0 0-2.561l-.097-.098Zm-.411-8.865 4.319 4.353c.14.142.14.371 0 .512l-.127.129a.357.357 0 0 1-.508 0l-4.32-4.354a.364.364 0 0 1 0-.512l.128-.128a.357.357 0 0 1 .508 0ZM10.79 9.906l3.15-2.459 2.64 2.661-2.44 3.176-3.35-3.378Zm3.454 5.018L9.162 9.802a.715.715 0 0 0-1.016 0l-.127.128 6.098 6.147.127-.128a.728.728 0 0 0 0-1.025Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttachmentPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attachment_pin.a4351e5e0b4ac11910440530d113c601.svg";